import { useRef } from "react";
import classNames from "classnames";
import { LitCheckbox } from "./LitCheckbox";

export interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  label?: string;
  title?: string;
  name: string;
  onChange: (checked: boolean) => void;
  "aria-label"?: string;
  align?: "center" | "start";
}

export default function Checkbox({
  label,
  title,
  onChange,
  checked,
  disabled = false,
  name,
  indeterminate,
  "aria-label": ariaLabel,
  align = "center"
}: CheckboxProps) {
  const checkboxRef = useRef<HTMLDivElement>(null);
  const alignStart = align === "start";
  const firstLineHeight = title ? "h-6" : "h-5";

  return (
    <div className="flex items-start" data-testid="checkbox" ref={checkboxRef}>
      <div className={classNames("flex shrink-0 items-center", firstLineHeight)}>
        <LitCheckbox
          className="shrink-0"
          data-testid={name}
          disabled={disabled}
          checked={checked}
          indeterminate={indeterminate}
          name={name}
          id={name}
          aria-label={ariaLabel}
          onChange={(e) => onChange((e.target as HTMLInputElement).checked)}
        />
      </div>
      <div className={classNames("ml-3 flex min-w-0 flex-col", { "flex-1": alignStart })}>
        {title && <p className="text-body-large mb-1 cursor-pointer">{title}</p>}
        {label && (
          <label
            className={classNames("text-body-medium cursor-pointer", {
              "text-gray-400": disabled,
              "break-words": alignStart
            })}
            htmlFor={name}
          >
            {label}
          </label>
        )}
      </div>
    </div>
  );
}
